import { ViewButton, ModifyButton, DeleteButton } from '../components/buttons';

export default ({ data, onClick, adminView = false, onManage, onRemove }) => {
    const { roles, email = 'email@emailaddress.com' } = data;

    const userProfile = data?.user_profile || {}

    const firstName = userProfile?.first_name || 'No last name';
    const lastName = userProfile?.last_name || 'No first name';
    const jobTitle = userProfile?.job_title || 'N/A';
    const telNo = userProfile?.tel_no || 'No Telephone'
    const profileImage = userProfile?.profile_img ? `/media/private/${userProfile?.profile_img}` : '/assets/user-icon-small.svg'

    return (
        <div class="team-member">
            <div class="team-member__header">
                <img src={profileImage} />
                <div>
                    <p class="user-info__role">{data.roles.map(role => role.name).join(', ')}</p>
                    <p>{ firstName }</p>
                    <p>{ lastName }</p>
                </div>
            </div>
            <div class="team-member__info">
                <p class="user-info__jobrole">{ jobTitle }</p>
                <p>{ email }</p>
            </div>
            { adminView &&
                <div className="utils__row utils__gap--20" style={{ marginTop: '20px' }}>
                    <ModifyButton mobile={true} onClick={onManage}/>
                    <DeleteButton mobile={true} onClick={onRemove}/>
                </div>
            }
        </div>
    )
}
